import store from "@/store";
export default function () {
    store.dispatch('initUserInfo');
    store.dispatch('initInternalCode');
    store.dispatch('initDetectStation');
    store.dispatch('initUserNameInfo');
}